/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Season_Summer_Winter_OptionInputs */



/**
* | output |
* | --- |
* | "Summer / Winter" |
*
* @param {Season_Summer_Winter_OptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const season_summer_winter_option = /** @type {((inputs?: Season_Summer_Winter_OptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Season_Summer_Winter_OptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer / Winter")
	return /** @type {LocalizedString} */ ("Été / Hiver")
});